module.exports = __webpack_public_path__ + "static/media/new-assessment-banner.d2b8eaef.png";